var _mask, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstructBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1874_1112",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H40V40H8C3.58172 40 0 36.4183 0 32V8Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H40V40H8C3.58172 40 0 36.4183 0 32V8Z",
    fill: "url(#paint0_linear_1874_1112)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-4 8C-4 1.37258 1.37258 -4 8 -4H40V4H8C5.79086 4 4 5.79086 4 8H-4ZM40 44H8C1.37258 44 -4 38.6274 -4 32H4C4 34.2091 5.79086 36 8 36H40V44ZM8 44C1.37258 44 -4 38.6274 -4 32V8C-4 1.37258 1.37258 -4 8 -4V4C5.79086 4 4 5.79086 4 8V32C4 34.2091 5.79086 36 8 36V44ZM40 0V40V0Z",
    fill: "white",
    mask: "url(#path-1-inside-1_1874_1112)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.6667C15.4 11.6667 11.6667 15.4001 11.6667 20.0001C11.6667 24.6001 15.4 28.3334 20 28.3334C24.6 28.3334 28.3333 24.6001 28.3333 20.0001C28.3333 15.4001 24.6 11.6667 20 11.6667ZM20.8333 25.8334H19.1667V24.1667H20.8333V25.8334ZM22.5583 19.3751L21.8083 20.1417C21.2083 20.7501 20.8333 21.2501 20.8333 22.5001H19.1667V22.0834C19.1667 21.1667 19.5417 20.3334 20.1417 19.7251L21.175 18.6751C21.4833 18.3751 21.6667 17.9584 21.6667 17.5001C21.6667 16.5834 20.9167 15.8334 20 15.8334C19.0833 15.8334 18.3333 16.5834 18.3333 17.5001H16.6667C16.6667 15.6584 18.1583 14.1667 20 14.1667C21.8417 14.1667 23.3333 15.6584 23.3333 17.5001C23.3333 18.2334 23.0333 18.9001 22.5583 19.3751Z",
    fill: "#6138F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1874_1112",
    x1: 4.96705e-7,
    y1: 6.66667,
    x2: 24.6154,
    y2: 43.5897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F8F5",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8D7FD",
    stopOpacity: 0.96
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructBtn);
export default __webpack_public_path__ + "static/media/instruct_btn.a3087830e7a48ea2c208df2032110975.svg";
export { ForwardRef as ReactComponent };